import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';
import Img from 'gatsby-image';

import Post from '../models/Post';

import SEO from './SEO';
import ShareButtons from './ShareButtons';

import styles from './Article.module.scss';

const dateFormat = 'D [de] MMMM [de] YYYY[,] HH:mm';

const Article = ({post}) => (
  <main className={styles.container}>
    <SEO title={post.title} description={post.excerpt} keywords={post.keywords} ogimage={post.ogimage} />
    <div className="wrap">
      <article className={styles.wrap}>
        <ul className={styles.categories}>
          {post.categories.map((cat, i) => (
            <li key={i}>{cat}</li>
          ))}
        </ul>

        <h2 className={styles.title}><Link to={post.uri} dangerouslySetInnerHTML={{__html: post.title}} /></h2>
        <p className={styles.excerpt} dangerouslySetInnerHTML={{__html: post.excerpt}} />

        <time className={styles.time}>{post.getTime(dateFormat)}</time>

        {
          post.thumbnail
            ? <Img fluid={post.thumbnail.fluid} alt={post.thumbnail.alt} />
            : null
        }

        <div className={styles.social}>
          Compartilhe:
          <ShareButtons title={post.title} url={post.getURL()} />
        </div>

        <div className={styles.text} dangerouslySetInnerHTML={{__html: post.html}} />
      </article>
    </div>
  </main>
);

Article.propTypes = {
  post: PropTypes.instanceOf(Post),
};

export default Article;
